export default __webpack_public_path__ + "static/media/braingif.918ccadb.gif";